import { MaintenanceForwardingDirectiveEntryStatus, MaintenanceForwardingSectionsProps } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type";

const DirectiveEntryStatusOnGoingDirective = ({
  forwarding,
}: MaintenanceForwardingSectionsProps) => {
  const directiveEntryStatus = forwarding.directive_entry.status;

  if (directiveEntryStatus === MaintenanceForwardingDirectiveEntryStatus.AwaitingManualStart) {
    return (
      <p className="text-warning">
        Pendente diagnóstico e orçamento
      </p>
    );
  }

  return null;
}

export default DirectiveEntryStatusOnGoingDirective;
